import { render, staticRenderFns } from "./Boxlog.vue?vue&type=template&id=db8094f6&scoped=true"
import script from "./Boxlog.vue?vue&type=script&lang=js"
export * from "./Boxlog.vue?vue&type=script&lang=js"
import style0 from "./Boxlog.vue?vue&type=style&index=0&id=db8094f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8094f6",
  null
  
)

export default component.exports